import script from "./DocumentAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentAccess.vue?vue&type=script&setup=true&lang=js"

import "./DocumentAccess.vue?vue&type=style&index=0&id=49a1b6e3&lang=css"

const __exports__ = script;

export default __exports__